export const defaultProductionReportForm = {
  report_id: "",
  resource_reserve_id: "",
  period_type: "year",
  as_of_date: "",
  fiscal_year: "",
  fiscal_quarter: "",
  reporting_currency: "USD",
  source_title: "",
  source_url: "",
  source_notes: "",
};

export const PERIOD_TYPE_OPTIONS = [
  { value: "year", label: "Annual" },
  { value: "quarter", label: "Quarter" },
];
